import styled from 'styled-components';
import { font, breakpoints } from '@chegg-ui/theme';
var family = font.family;
export var CtaContainer = styled.div.withConfig({
  componentId: "sc-768hhi-0"
})(["font-family:", ";@media (max-width:", "){button{width:100%;}}"], family.aspira, breakpoints.md.max);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/CTA/styled.js
// module id = 3970
// module chunks = 11